/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TimeControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any System time
     * @throws ApiError
     */
    public timeControllerGetSystemTime(): CancelablePromise<{
        datetime?: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/time',
        });
    }
}
